import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-background-animation">
        <div className="animated-shape shape-1"></div>
        <div className="animated-shape shape-2"></div>
        <div className="animated-shape shape-3"></div>
        <div className="animated-shape shape-4"></div>
        <div className="animated-shape shape-5"></div>
      </div>
      <div className="hero-container">
        <div className="hero-header-full" data-aos="fade-up">
          <div className="hero-badge" data-aos="fade-up" data-aos-delay="100">
            <span>🚀 Transform Your Digital Vision</span>
          </div>
          <h1 className="hero-title">
                We Build Fast, Modern & <span className="gradient-text">Scalable Digital</span><br />
            <span className="gradient-text">Experiences</span>
          </h1>
        </div>
        <div className="hero-content-grid">
          <div className="hero-content" data-aos="fade-up" data-aos-delay="200">
            <p className="hero-subtitle">
              From full-stack apps to e-commerce platforms, Shawave Technologies transforms your ideas into clean, 
              high-performance digital products that look stunning and deliver results.
            </p>
            <div className="hero-highlights">
              <div className="highlight-item" data-aos="fade-up" data-aos-delay="300">
                <div className="highlight-icon">✓</div>
                <span>Full-Stack Web & App Development</span>
              </div>
              <div className="highlight-item" data-aos="fade-up" data-aos-delay="350">
                <div className="highlight-icon">✓</div>
                <span>E-Commerce Websites & Apps</span>
              </div>
              <div className="highlight-item" data-aos="fade-up" data-aos-delay="400">
                <div className="highlight-icon">✓</div>
                <span>Android & iOS Solutions</span>
              </div>
              <div className="highlight-item highlight-price" data-aos="fade-up" data-aos-delay="450">
                <div className="highlight-icon">₹</div>
                <span>Starting at just ₹4,999</span>
              </div>
            </div>
            <div className="hero-buttons" data-aos="fade-up" data-aos-delay="500">
              <button 
                className="btn btn-primary"
                onClick={() => scrollToSection('contact')}
              >
                <span>Start Your Project</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <button 
                className="btn btn-secondary"
                onClick={() => scrollToSection('pricing')}
              >
                <span>Get a Free Quote</span>
              </button>
            </div>
          </div>
          <div className="hero-visual" data-aos="fade-left" data-aos-delay="300">
            <div className="hero-animation-container">
              <div className="floating-element element-1">
                <div className="element-content">⚡</div>
              </div>
              <div className="floating-element element-2">
                <div className="element-content">🚀</div>
              </div>
              <div className="floating-element element-3">
                <div className="element-content">💎</div>
              </div>
              <div className="floating-element element-4">
                <div className="element-content">✨</div>
              </div>
              <div className="hero-gradient-orb"></div>
              <div className="hero-grid-pattern"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
        <div className="arrow">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </section>
  );
};

export default Hero;

